import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { Phase, StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import React from 'react';
import { useSelector } from 'react-redux';
import SievePortionPreparationSectionDriedMaterial from './SievePortionPreparationSectionDriedMaterial';
import SievePortionPreparationSectionDryingAfterSeparation from './SievePortionPreparationSectionDryingAfterSeparation';
import SievePortionPreparationSectionDryingBeforeSeparationWithMoist from './SievePortionPreparationSectionDryingBeforeSeparationWithMoist';
import SievePortionPreparationSectionDryingBeforeSeparationWithOvenDry from './SievePortionPreparationSectionDryingBeforeSeparationWithOvenDry';

let SievePortionPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const dryingPhase = useSelector(createWorksheetSelector!('Preparation.DryingPhase')) as Phase;
  const totalDryMassDeterminationBy = useSelector(
    createWorksheetSelector!('Preparation.TotalDryMassDeterminationBy')
  ) as StateOfMaterial;

  return (
    <PageSection heading="Sieve Portion Preparation">
      <NamePrefixModifier appendNamePrefix="WholePortion.Masses">
        {dryingPhase === Phase.Never && <SievePortionPreparationSectionDriedMaterial />}
        {dryingPhase === Phase.WholePortion && totalDryMassDeterminationBy === StateOfMaterial.Moist && (
          <SievePortionPreparationSectionDryingBeforeSeparationWithMoist />
        )}
        {dryingPhase === Phase.WholePortion && totalDryMassDeterminationBy === StateOfMaterial.OvenDry && (
          <SievePortionPreparationSectionDryingBeforeSeparationWithOvenDry />
        )}
        {(dryingPhase === Phase.AfterFirstSeparation || dryingPhase === Phase.AfterSecondSeparation) && (
          <SievePortionPreparationSectionDryingAfterSeparation />
        )}
      </NamePrefixModifier>
    </PageSection>
  );
};

SievePortionPreparationSection = withInjectedProps(SievePortionPreparationSection);

export { SievePortionPreparationSection };
export default SievePortionPreparationSection;
